// extracted by mini-css-extract-plugin
export default {"root":"LandscapeTopActions-module__root","button":"LandscapeTopActions-module__button","icon":"LandscapeTopActions-module__icon","label":"LandscapeTopActions-module__label"};